import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {LoadingService} from "../services/LoadingService";
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {SwitchBoard} from "../services/SwitchBoard";
import {Router} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {Session} from "../services/Session";

declare const moment: any;

@Component({
  selector: 'app-terms',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss'
})
export class TermsComponent implements OnInit, OnDestroy {
  user: any;
  termsAcceptedBy: string;
  termsAndConditionsText: string;

  destroy$: EventEmitter<void> = new EventEmitter<void>();
  constructor(
    private _router: Router,
    private switchBoard: SwitchBoard,
    private loadingService: LoadingService,
    private taxPlanningService: TaxPlanningService
  ) {}

  ngOnInit(): void {
    this.user = Session.getUser();
    this.switchBoard.onPageChangeListener.next({});
    this.getTerms();
  }

  getTerms(){
    this.taxPlanningService.getTermsAndConditions(Session.getOrg(), this.user.id).subscribe(response => {
      this.termsAndConditionsText = response.content;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  accept(){
    const terms = {
      termsAccepted: true,
      acceptedUserName: this.termsAcceptedBy,
      acceptedBy: this.user.id,
      acceptedDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.acceptTerms(Session.getOrg(), this.user.id, terms).subscribe(acceptedTerms => {
      this.loadingService.triggerLoadingEvent(false);
      this.taxPlanningService.setUserFirstLogin(true);
      if (acceptedTerms.termsAccepted){
        this.taxPlanningService.setTerms(acceptedTerms);
      }
      const accessInfo: any = Session.getUserAccessInfo();
      if (accessInfo && accessInfo.subscriptionStatus == 'Suspended') {
        this._router.navigate(['tax-planning/manage-billing']);
        return;
      } else {
        this.switchBoard.onBillingDetailsApproved.next({});
      }
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
    });
  }

  decline(){
    this.switchBoard.onLogOut.next({});
  }

  onLoadChargeBeePortal() {
    const base = this;
    setTimeout(function () {
      base.loadingService.triggerLoadingEvent(false);
    }, 3000);
  }

}
